import { LoadingOutlined } from '@ant-design/icons';
import { Progress, Spin } from 'antd';
import * as React from 'react';
import { LOADER_TEXT_FONT_SIZE } from './FullPageLoader';
import { formatDownload, megabytes } from '../../Service/OfflineSaveService';

// Same overlay, spinner and type as the page loader for 'Save Offline and 'Download KML' with progress bar
const overlay: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999
};

const line: React.CSSProperties = {
  color: 'white',
  fontSize: LOADER_TEXT_FONT_SIZE - 4,
  fontWeight: 'bold',
  textAlign: 'center'
};

export interface DownloadLoaderProps {
  /** What is being downloaded, above the bar: "Saving the trees for offline use", "Saving the KML file"… */
  title: string;
  /** Bytes received so far, and the size promised before the download started */
  bytes: number;
  expectedBytes: number;
}

/** The one overlay a download reports through: the title says which one, the bar and the MB line follow the bytes */
export default function DownloadLoader({ title, bytes, expectedBytes }: DownloadLoaderProps) {
  // Both figures come from the size the dialog promised: a download that overshoots cannot push the bar past its end
  const percent = expectedBytes > 0 ? Math.round(Math.min(100, (bytes / expectedBytes) * 100)) : 0;

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return (
    <div style={overlay}>
      <div className='loader' style={{
        width: '80%',
        maxWidth: '420px',
        margin: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      }}>
        <Spin indicator={antIcon} size='large' />

        <span style={{
          color: 'white',
          fontSize: LOADER_TEXT_FONT_SIZE,
          marginTop: '20px',
          fontWeight: 'bold'
        }}>
          {title}
        </span>

        <div style={{ width: '100%', margin: '20px 0 14px' }}>
          <Progress
            percent={percent}
            showInfo={false}
            strokeColor='#1890ff'
            trailColor='rgba(255,255,255,0.3)'
          />
        </div>

        <span style={line}>
          {megabytes(bytes)} downloaded / {formatDownload(expectedBytes)}
        </span>
      </div>
    </div>
  );
}
